// extracted by mini-css-extract-plugin
export default {"app":"app--0ERvM","main-wrapper":"main-wrapper--dpUnr","mainWrapper":"main-wrapper--dpUnr","main":"main--ttaNC"};